<div class="modal" [ngClass]="navaidService.activeAngles ? 'active' : ''">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Add Angles</h2>
      <div class="close" (click)="cancelAngle()">
        <img src="/assets/img/close-white.svg" alt="" />
      </div>
      <div class="fields__container">
        <form autocomplete="off"  class="active" (ngSubmit)="addAngle()">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="input-fields">
                <div>
                  <label for="">Vertical Angle</label>
                  <div class="coordenates">
                    <input
                      name="verticalangle"
                      type="number"
                      [ngClass]="!verticalAngleValid ? 'ng-invalid' : ''"
                      [(ngModel)]="angle.verticalangle"
                      (ngModelChange)="isValueValid('verticalangle', angle.verticalangle);"
                      required="true"
                    /><span>º</span>
                    <span class="error" *ngIf="!verticalAngleValid">
                      The Vertical Angle value should be defined between -90 and 90 degrees.
                    </span>
                  </div>
                </div>
                <div>
                  <label for="">Min Angle </label>
                  <div class="coordenates">
                    <input
                      type="number"
                      name="minangle"
                      required="true"
                      [ngClass]="!minAlgleValid ? 'ng-invalid' : ''"
                      [(ngModel)]="angle.minangle"
                      (ngModelChange)="isValueValid('minangle', angle.minangle);isBiggerThen($event, angle.maxangle);"
                    /><span>º</span>
                    <span class="error" *ngIf="!minAlgleValid">
                      The Min Angle value should be defined between 0 and 360 degrees.
                    </span>
                  </div>

                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Max Angle </label>
                  <div class="coordenates">
                    <input
                      type="number"
                      name="maxangle"
                      required="true"
                      [ngClass]="!maxAngleValid ? 'ng-invalid' : ''"
                      [(ngModel)]="angle.maxangle"
                      (ngModelChange)="isValueValid('maxangle', angle.maxangle);isBiggerThen(angle.minangle, $event);"
                    /><span>º</span>
                    <span class="error" *ngIf="!maxAngleValid">
                      The Max Angle value should be defined between 0 and 360 degrees.
                    </span>
                    <span class="error" *ngIf="isBiggerThenValid">
                      The Max Angle value should be higher than the Min Angle Value.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button
              type="submit"
              [ngClass]="checkFormValid() ? 'blue' : 'gray'"
              (click)="addAngle();"
              [disabled]="!checkFormValid()"
            >
              Add
            </button>
            <a
              class="gray"
              href="#"
              type="reset"
              value="Cancel"
              (click)="cancelAngle()"
              >Cancel</a
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
